import { render, staticRenderFns } from "./AsideNotifications.vue?vue&type=template&id=8847630e&scoped=true&"
import script from "./AsideNotifications.vue?vue&type=script&lang=js&"
export * from "./AsideNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AsideNotifications.vue?vue&type=style&index=0&id=8847630e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8847630e",
  null
  
)

export default component.exports